var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showHotelequia && _vm.hotelequiaURL.length > 0)?_c('div',{staticClass:"chat-window",staticStyle:{"bottom":"200px !important"},attrs:{"id":"chat-bot"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }